export enum WorkingArea {
	Unknown = 0,
	'TV & Film' = 1,
	Advertising = 2,
	'Brands & Business' = 3,
	'Audio Entertainment' = 4,
	Games = 5,
	'Individual Creator' = 6,
	Other = 7,
}
